<template>
  <image-manager :isLogo="isLogo"/>
</template>

<script>
import ImageManager from '@/components/ImageManager/ImageManager'

export default {
  props: [
    'isLogo',
  ],
  components: {
    ImageManager,
  }
}
</script>
